import styled, { css } from 'styled-components';
import { CloudCircle } from '@mui/icons-material';

export const BucketIcon = styled(CloudCircle)(
	({ theme }) => css`
		color: ${theme.palette.primary.main};
		vertical-align: middle;
	`,
);
